import { Autocomplete, Box, Button, Drawer, FormControl, InputLabel, MenuItem, Select, Stack, TextField, Tooltip, Typography } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import '../reports.css';
import React, { useEffect, useState } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import { AmountsCard } from '../../../../Components/CommonCards/CommonCards'
import { ImagePaths } from '../../../../Utility/ImagePaths';
import { withTranslation } from 'react-i18next';
import { DateTime } from 'luxon';
import { CommonGridToolBarWithFilterText } from '../../../../Components/Common Components/CommonComponents';
import { formatDate } from '../../../../Components/CommonFunctions/CommonFunctions';
import CommonDatePicker from '../../../../Components/Common Components/CommonDatePicker';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { localGetItem } from '../../../../Utility/Services/CacheProviderService';



// OP brnach Report to OP Referral Source 
const IPReferralsource = ({ t }) => {
    const paymentStatusList = [
        { name: 'Paid', value: 'paid' },
        { name: 'Partial', value: 'partial' },
        { name: 'Not Paid', value: 'not paid' },
    ]
    
    const moduleTypeList = [
        { label: 'IP', value: 'IP' },
        { label: 'OT', value: 'OT' },
        ...(localGetItem("Show_Pharmacy_Bills_In_FO") === "true") ? [{ label: 'Pharmacy', value: 'Pharmacy' }] : []
    ]
    const [cardValue, setCardValue] = useState({
        billAmt: 0,
        ConsessAmt: 0,
        PaidAmt: 0,
        companyAmt: 0,
        netAmt: 0,
    })
    const [filters, setFilters] = useState({
        FilterOpen: false,
        fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
        toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
        dateIndex: 1,
        paymentStatus: null,
        selectBranch: [],
        creditType: '',
        moduleType: [{ label: 'IP', value: 'IP' }],
    })
    const [dataList, setDatalist] = useState([])
    const [page, setPage] = useState(0)
    const [pageSize, setPageSize] = useState(10)
    const [isLoader, setIsLoader] = useState(false)
    const [errorMsg, setErrorMsg] = useState(false)
    const [errorMsgText, setErrorMsgText] = useState("")
    const [refSource, setrefSource] = useState([])
    const [disBtn, setdisBtn] = useState(false)

    useEffect(() => {
        getOPbranchData()
        getReferralsource()
    }, [])

    const getOPbranchData = (customFilters = filters) => {
        try {
            setIsLoader(true)
            let FromDate = customFilters?.fromDate
            let ToDate = customFilters?.toDate
            let paymentStatus = customFilters?.paymentStatus?.value || ''
            let branchNameS = []
            customFilters?.selectBranch?.forEach(element => branchNameS.push(element.source_name))
            let credit = customFilters?.creditType
            let moduleType = customFilters?.moduleType?.map(m => m.value) || []
            RestAPIService.getAll(`${Serviceurls.IP_BRANCH_GET}?from_date=${FromDate}&to_date=${ToDate}&payment_status=${paymentStatus}&referral_source=${branchNameS}&credit_type=${credit}&module_type=${moduleType}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setIsLoader(false)
                        setDatalist(response?.data?.data || [])
                        setCardValue(prev => ({
                            billAmt: response?.data?.total_bill_amount || 0,
                            ConsessAmt: response?.data?.total_concession || 0,
                            PaidAmt: response?.data?.total_paid_amount || 0,
                            companyAmt: response?.data?.total_company_amount || 0,
                            netAmt: response?.data?.total_net_amount || 0,
                        }))
                    }
                })
                .catch((e) => {
                    setIsLoader(false)
                    errorMessage(e?.response?.data?.message || e?.message)
                })
        } catch (e) {
            setIsLoader(false)
            errorMessage(e?.message)
        }
    }

    const getReferralsource = () => {
        try {
            RestAPIService.getAll(`${Serviceurls.FO_CONFIG_REF_SOURCE}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setrefSource(response?.data?.data || [])
                    }
                })
                .catch((e) => {
                    errorMessage(e?.response?.data?.message || e?.message)
                })
        } catch (e) {
            errorMessage(e?.message)
        }
    }

    const getOPbranchDataExcel = (customFilters = filters) => {
        try {
            setdisBtn(true)
            let FromDate = customFilters?.fromDate
            let ToDate = customFilters?.toDate
            let paymentStatus = customFilters?.paymentStatus?.value || ''
            let branchNameS = []
            customFilters?.selectBranch?.forEach(element => branchNameS.push(element.source_name))
            let credit = customFilters?.creditType
            let moduleType = customFilters?.moduleType?.map(m => m.value) || []
            RestAPIService.excelGet(`${Serviceurls.IP_BRANCH_GET}?from_date=${FromDate}&to_date=${ToDate}&payment_status=${paymentStatus}&referral_source=${branchNameS}&credit_type=${credit}&module_type=${moduleType}&export_type=excel`)
                .then((response) => {
                    if (response.data) {
                        var pom = document.createElement('a');
                        var csvContent = response.data;
                        let filename = response.headers["content-disposition"]?.split("filename=")[1]
                        var blob = new Blob([csvContent], { type: 'application/x-www-form-urlencoded; charset=UTF-8' }); // text/csv;charset=utf-8;
                        var url = URL.createObjectURL(blob);
                        pom.href = url;
                        pom.setAttribute('download', filename ? filename : 'registry.xlsx');
                        pom.click();
                        setdisBtn(false)
                    }
                }).catch((e) => {
                    setdisBtn(false)
                    errorMessage(e?.response?.data?.message || e?.message)
                });
        } catch (e) {
            setdisBtn(false)
            errorMessage(e?.message)
        }
    }

    const errorMessage = (msg) => {
        setErrorMsg(true);
        setErrorMsgText(msg);
    }
    const msgClose = () => {
        setErrorMsg(false);
        setErrorMsgText("")
    }
    const gridToolBar = () => {
        let TextArray = [
            { label: "From Date", value: formatDate(filters?.fromDate) },
            { label: "To Date", value: formatDate(filters?.toDate) },
        ]
        return (
            <Box>
                <CommonGridToolBarWithFilterText FilterTextArray={TextArray} />
            </Box>

        )
    }

    const FilterDate = (from, to, index) => {
        setFilters((prev) => ({
            ...prev,
            fromDate: from,
            toDate: to,
            dateIndex: index
        }))
    }

    const renderFilterScreen = () => {
        return (
            <Box component={"div"} className='eMed_rts_filter_container'>
                <Box component={"div"} className='eMed_filter_Top'>
                    <Typography variant='h6' fontWeight={600}>{("Filter")}</Typography>
                    <Button onClick={() => { setFilters(prev => ({ ...prev, FilterOpen: false })) }} className='eMed_usrconf_btn'>
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </Box>
                <Box className='eMed_rts_middle'>
                    <Box className='eMed_date_filter'>
                        <CommonDatePicker
                            FromDate={filters.fromDate}
                            ToDate={filters.toDate}
                            DateIndex={filters.dateIndex}
                            SelectedDates={FilterDate}
                            HideAllMenu={true} />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <Autocomplete
                            options={paymentStatusList}
                            getOptionLabel={(options) => options.name || ''}
                            onChange={(e, value) => {
                                setFilters(prev => ({
                                    ...prev,
                                    paymentStatus: value
                                }))
                            }}
                            value={filters?.paymentStatus}
                            id="payment-status-combo"
                            renderInput={(params) => <TextField {...params} label={t('Select Payment Status')} size='small' />}
                        />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <Autocomplete
                            multiple
                            limitTags={1}
                            options={refSource || []}
                            getOptionLabel={(options) => options.source_name || ''}
                            onChange={(e, value) => {
                                setFilters(prev => ({
                                    ...prev,
                                    selectBranch: value
                                }))
                            }}
                            value={filters?.selectBranch || []}
                            id="combo-box"
                            renderInput={(params) => <TextField {...params} label={t('Select Referral Source')} size='small' />}
                        />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <FormControl size='small' fullWidth>
                            <InputLabel id="demo-simple-select-label">{'Select Credit Type'}</InputLabel>
                            <Select
                                clear
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={filters?.creditType}
                                label="Select Credit Type"
                                onChange={(event) => {
                                    setFilters(prev => ({
                                        ...prev,
                                        creditType: event.target.value
                                    }))
                                }}
                            >
                                <MenuItem value={'Patient credit'}>{'Patient Credit'}</MenuItem>
                                <MenuItem value={'Insurance credit'}>{'Insurance Credit'}</MenuItem>
                                <MenuItem value={'Corporate credit'}>{'Corporate Credit'}</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <Autocomplete
                            multiple
                            size='small'
                            limitTags={1}
                            options={moduleTypeList}
                            getOptionLabel={(option) => option.label}
                            isOptionEqualToValue={(option, value) => option.value === value.value}
                            onChange={(e, value) => {
                                setFilters(prev => ({
                                    ...prev,
                                    moduleType: value
                                }))
                            }}
                            value={filters?.moduleType || []}
                            id="module-type-combo"
                            renderInput={(params) => <TextField {...params} label={t('Select Module Type')} size='small' />}
                        />
                    </Box>
                </Box>
                <Box component={'div'} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Button variant='outlined' size="small" sx={{ mr: '1rem' }}
                        onClick={() => {
                            const newFilters = {
                                ...filters,
                                fromDate: DateTime.now().toFormat('yyyy-MM-dd'),
                                toDate: DateTime.now().toFormat('yyyy-MM-dd'),
                                dateIndex: 1,
                                paymentStatus: null,
                                selectBranch: [],
                                FilterOpen: false,
                                creditType: '',
                                moduleType: [{ label: 'IP', value: 'IP' }],
                            }
                            setFilters(newFilters)
                            getOPbranchData(newFilters)
                        }}
                        id="eMed_Config_btn">{("Clear")}</Button>
                    <Button variant='contained' size="small"
                        onClick={() => {
                            const newFilters = {
                                ...filters,
                                FilterOpen: false
                            }
                            setFilters(newFilters)
                            getOPbranchData(newFilters)

                        }}
                        id="eMed_Config_btn">{("Search")}</Button>
                </Box>
            </Box>
        )
    }
    const closeFilter = () => {
        setFilters(prev => ({ ...prev, FilterOpen: false }))
    }


    dataList?.forEach((element, index) => element.sno = index + 1)
    const columns = [
        {
            field: "sno",
            headerName: t("S No"),
            flex: 0.1,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => (<Box component={'div'}>{params?.row?.sno ? params?.row?.sno : "-"}</Box>),
        },
        {
            field: "bill_no",
            headerName: t("Bill No"),
            flex: 0.25,
            headerAlign: "center",
            align: "left",
            renderCell: (params) => (<Box component={'div'}>{params?.row?.bill_no?.length > 8 ?
                <Tooltip placement='top' title={params?.row?.bill_no} arrow><Box>{"..." + params?.row?.bill_no.slice(-8)}</Box></Tooltip>
                : params?.row?.bill_no ? params?.row?.bill_no : "-"}</Box>),
        },
        {
            field: "date",
            headerName: t("Bill Date"),
            flex: 0.25,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => (<Box component={'div'}>{params?.row?.date?.length > 8 ?
                <Tooltip placement='top' title={params?.row?.date} arrow><Box>{params?.row?.date.slice(0, 8) + '...'}</Box></Tooltip>
                : params?.row?.date ? params?.row?.date : "-"}</Box>),
        },
        {
            field: "surgery_date",
            headerName: t("Surgery Dt"),
            flex: 0.25,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => (<Box component={'div'}>{params?.row?.surgery_date?.length > 8 ?
                <Tooltip placement='top' title={params?.row?.surgery_date} arrow><Box>{params?.row?.surgery_date.slice(0, 8) + '...'}</Box></Tooltip>
                : params?.row?.surgery_date ? params?.row?.surgery_date : "-"}</Box>),
        },
        {
            field: "uhid_no",
            headerName: t("UHID"),
            flex: 0.25,
            renderCell: (params) => (<Box component={'div'}>{params?.row?.uhid_no?.length > 8 ?
                <Tooltip placement='top' title={params?.row?.uhid_no} arrow><Box>{"..." + params?.row?.uhid_no.slice(-8)}</Box></Tooltip>
                : params?.row?.uhid_no ? params?.row?.uhid_no : "-"}</Box>),
        },
        {
            field: "branch_uhid",
            headerName: t("Referral Source"),
            flex: 0.25,
            renderCell: (params) => (<Box component={'div'}>{params?.row?.branch_uhid?.length > 8 ?
                <Tooltip placement='top' title={params?.row?.branch_uhid} arrow><Box>{params?.row?.branch_uhid.slice(0, 8) + '...'}</Box></Tooltip>
                : params?.row?.branch_uhid ? params?.row?.branch_uhid : "-"}</Box>),
        },
        {
            field: "patient_name",
            headerName: t("Patient Name"),
            flex: 0.35,
            renderCell: (params) => (<Box component={'div'}>{params?.row?.patient_name?.length > 10 ?
                <Tooltip placement='top' title={params?.row?.patient_name} arrow><Box>{params?.row?.patient_name.slice(0, 10) + "..."}</Box></Tooltip>
                : params?.row?.patient_name ? params?.row?.patient_name : "-"}</Box>),
        },
        {
            field: "bill_type",
            headerName: t("Bill Type"),
            flex: 0.2,
            align: "center",
            renderCell: (params) => (
                <Box>
                    <Typography fontWeight={'bold'}>{params?.row?.bill_type ? params?.row?.bill_type : "-"}</Typography>
                    <Typography fontSize={'0.8vw'}>{params?.row?.payment_status ? params?.row?.payment_status : "-"}</Typography>
                </Box>
            ),
        },
        {
            field: "mode",
            headerName: t("Mode"),
            flex: 0.3,
            renderCell: (params) => (
                <Box>
                    <Typography fontSize={'0.8vw'} fontWeight={'bold'}>{params?.row?.module_type ? params?.row?.module_type : "-"}</Typography>
                    <Box component={'div'}>{params?.row?.mode?.length > 10 ?
                        <Tooltip placement='top' title={params?.row?.mode} arrow><Typography fontSize={'0.8vw'}>{params?.row?.mode.slice(0, 10) + "..."}</Typography></Tooltip>
                        : <Typography fontSize={'0.8vw'}>{params?.row?.mode ? params?.row?.mode : "-"}</Typography>}
                    </Box>
                </Box>
            ),
        },
        {
            field: "company",
            headerName: t("Credit Type"),
            flex: 0.35,
            renderCell: (params) => {
                const row = params?.row;
                const renderText = (value) => {
                    if (!value) return "-";

                    return value.length > 14 ? (
                        <Tooltip placement="top" title={value} arrow>
                            <Typography fontSize={"0.8vw"}>{value.slice(0, 14) + "..."}</Typography>
                        </Tooltip>
                    ) : (
                        value
                    );
                };

                if (row?.credit_type === "Corporate credit") {
                    return (
                        <Box>
                            <Box component="div">
                                {'Corporate Credit'}
                            </Box>

                            <Typography component="div" fontSize={"0.8vw"}>
                                {renderText(row?.company_name)}
                            </Typography>
                        </Box>
                    );
                }

                if (row?.credit_type === "Insurance credit") {
                    return (
                        <Box>
                            <Box component="div">
                                {'Insurance Credit'}
                            </Box>

                            <Typography component="div" fontSize={"0.8vw"}>
                                {renderText(row?.insurance_company_name)}
                            </Typography>
                        </Box>
                    );
                }

                return (
                    <Box component="div">
                        {row?.company ? 'Patient Credit' : "-"}
                    </Box>
                );
            }
        },
        {
            field: "bill_amount",
            headerName: t("Bill Amount"),
            flex: 0.2,
            align: "right",
            headerAlign: "center",
            renderCell: (params) => (<Box component={'div'}><Typography fontSize={'.9vw'}>{params?.row?.bill_amount ? params?.row?.bill_amount : "0"}</Typography></Box>),
        },
        {
            field: "concession",
            headerName: t("Concession"),
            flex: 0.2,
            align: "right",
            headerAlign: "center",
            renderCell: (params) => (<Box component={'div'}><Typography fontSize={'.9vw'}>{params?.row?.concession ? params?.row?.concession : "0"}</Typography></Box>),
        },
        {
            field: "net_amount",
            headerName: t("Net Amt"),
            flex: 0.2,
            align: "right",
            headerAlign: "center",
            renderCell: (params) => (<Box component={'div'}><Typography fontSize={'.9vw'}>{params?.row?.net_amount ? params?.row?.net_amount : "0"}</Typography></Box>),
        },
        {
            field: "company_amount",
            headerName: t("Credit Amt"),
            flex: 0.25,
            align: "right",
            headerAlign: "center",
            renderCell: (params) => (<Box component={'div'}><Typography fontSize={'.9vw'}>{params?.row?.company_amount ? params?.row?.company_amount : "0"}</Typography></Box>),
        },
        {
            field: "paid_amount",
            headerName: t("Paid Amt"),
            flex: 0.25,
            align: "right",
            headerAlign: "center",
            renderCell: (params) => (<Box component={'div'}><Typography fontSize={'.9vw'}>{params?.row?.paid_amount ? params?.row?.paid_amount : "0"}</Typography></Box>),
        },
    ];

    return (
        <Box component={'div'} className='eMed_rts_container'>
            <Box component={"div"} className='eMed_Top_Container'>
                <Box component={"div"} className='eMed_Cards_Container'>
                    {AmountsCard(t("Bill Amount"), cardValue?.billAmt)}
                    {AmountsCard(t("Concession Amount"), cardValue?.ConsessAmt)}
                    {AmountsCard(t("Net Amount"), cardValue?.netAmt)}
                    {AmountsCard(t("Credit Amount"), cardValue?.companyAmt)}
                    {AmountsCard(t("Paid Amount"), cardValue?.PaidAmt)}
                </Box>
                <Box component={"div"} className='eMed_Action_Container'>
                    <Box component={"div"} className='eMed_Filter_Icon_div'>
                        <Button className='eMed_usrconf_btn' onClick={() => { setFilters(prev => ({ ...prev, FilterOpen: true })) }}>
                            <img src={ImagePaths.Filter.default} alt="filter" className='eMed_action_img' />
                        </Button>
                    </Box>
                    <Button className='eMed_usrconf_btn' onClick={() => {
                        if (dataList?.length) {
                            getOPbranchDataExcel()
                        } else {
                            errorMessage("No data to export")
                        }
                    }}>
                        <img src={ImagePaths.ExportIcon.default} alt="print" className='eMed_action_img' />
                    </Button>
                </Box>
            </Box>
            <Box component={'div'} className='eMed_rts_table'>
                <DataGrid
                    rows={dataList}
                    columns={columns}
                    getRowId={(row) => row['sno']}
                    page={page}
                    pageSize={pageSize}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Stack className='eMed_conf_nodata'>
                                {t("NoRecordsFound")}
                            </Stack>
                        )
                    }}
                    onPageChange={(newPage) => { setPage(newPage) }}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    rowsPerPageOptions={[10, 20, 30]}
                    pagination
                    headerHeight={40}
                    disableSelectionOnClick
                    loading={isLoader}
                />
            </Box>
            <Drawer
                anchor={'right'}
                open={filters?.FilterOpen}
                ModalProps={{ onBackdropClick: closeFilter }}
            >
                {renderFilterScreen()}
            </Drawer>
            {errorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
        </Box>
    )
}


export default withTranslation()(IPReferralsource);